import { api } from "@/lib/api";
import { createDocuments } from "@/lib/documents";

export const DocumentsRepository = createDocuments(api.documents, (url, init) => fetch(url, init));
